const ERROR_NAMESPACE = 'adtech_mobile_web';

export const MOBILE_ERROR_MESSAGES = {
  LOAD_FAILED: `${ERROR_NAMESPACE}_load_failed`,
  UPDATE_STATE_FAILED: `${ERROR_NAMESPACE}_update_state_failed`,
  UPDATE_CHANNEL_FAILED: `${ERROR_NAMESPACE}_update_channel_failed`,
  UPDATE_TERMS_FAILED: `${ERROR_NAMESPACE}_update_terms_failed`,
  ERROR_BOUNDARY: `${ERROR_NAMESPACE}_error_boundary`,
};
